import {Formik} from 'formik';
import {object, string} from 'yup';
import {DeprecatedButton} from '@shipwell/shipwell-ui';
import TriumphPayAuditFields from 'App/formComponents/formSections/triumphPayAuditFields';
import useUpdateTriumphpayauditRegistration from 'App/containers/integrations/details/components/triumphPayAuditDetails/hooks/useUpdateTriumphpayauditRegistration';
import {useUserMe} from 'App/data-hooks';
import WithStatusToasts, {WithStatusToastProps} from 'App/components/withStatusToasts';
import {getV3ApiErrorDetail} from 'App/api/typedUtils';
import {setTpaAlias} from 'App/containers/integrations/details/components/triumphPayAuditDetails/utils';

/** Default values needed for Formik */
const defaultFormValues = {
  tpa_api_key: '',
  tpa_alias: ''
};

export const validationSchema = object().shape({
  tpa_api_key: string().required('Api key is required.').nullable(),
  tpa_alias: string().required('Account alias is required.').nullable()
});

type ValuesProps = {
  tpa_api_key: string;
  tpa_alias: string;
};

/**
 * TriumphPay Form
 */
const TriumphPayForm = ({setSuccess, setError}: WithStatusToastProps) => {
  const {mutate, isLoading} = useUpdateTriumphpayauditRegistration({
    onSuccess: ({data}) => {
      setTpaAlias(data.tpa_alias);
      setSuccess('Success!', 'You have connected TriumphPay Audit integration.');
    },
    onError: (error) => {
      setError('Error!', getV3ApiErrorDetail(error, 'Something went wrong, please try again.'));
    }
  });
  const {data} = useUserMe();

  const handleSubmit = (values: ValuesProps) => {
    mutate({
      ...values,
      company_id: data?.company?.id || '',
      user_id: data?.user?.id || ''
    });
  };

  return (
    <Formik validationSchema={validationSchema} initialValues={defaultFormValues} onSubmit={handleSubmit}>
      {({handleSubmit}) => (
        <form onSubmit={handleSubmit} noValidate>
          <TriumphPayAuditFields />
          <div className="flex justify-end gap-4">
            <DeprecatedButton
              type="submit"
              disabled={isLoading}
              icon={isLoading ? <i className="icon icon-Restart rotate" /> : null}
            >
              Validate
            </DeprecatedButton>
          </div>
        </form>
      )}
    </Formik>
  );
};

export default WithStatusToasts(TriumphPayForm);
